module.exports = __webpack_public_path__ + "static/media/features_background.fd3bf1d2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/features_background.jpg
// module id = 522
// module chunks = 0